import styled from 'styled-components';
import { fontSizes, paddings } from '~/styled/variables';
import { zBanners } from '~/styled/z-index';

export const BannerDiv = styled.div`
  position: sticky;
  top: 0;
  z-index: ${zBanners};
  box-sizing: border-box;
  display: flex;
  align-items: center;
  gap: ${paddings.mediumPadding};
  height: 80px;
  padding: 0 ${paddings.defaultPadding};
  background-color: var(--surface);
  backdrop-filter: blur(27px);
  box-shadow: inset 0 -1px 0 0 var(--ui-gray500);
`;

export const CloseButton = styled.button`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 24px;
  height: 24px;
  padding: 0;
  border: 0;
  background: transparent;
  color: var(--on-surface);
  cursor: pointer;
  flex: 0 0 auto;
`;

export const IconImg = styled.img`
  width: 64px;
  height: 64px;
  border-radius: 12px;
  flex: 0 0 auto;
`;

export const TextDiv = styled.div`
  display: flex;
  flex-direction: column;
  flex: 1 1 auto;
  min-width: 0;
  overflow: hidden;
`;

export const TitleSpan = styled.span`
  font-size: ${fontSizes.fontSizeBody};
  font-weight: 600;
  color: var(--on-surface);
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
`;

export const SubtitleSpan = styled.span`
  font-size: ${fontSizes.fontSizeCaption};
  color: var(--ui-gray500);
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
`;

export const StoreSpan = styled.span`
  font-size: ${fontSizes.fontSizeCaption};
  color: var(--ui-gray500);
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
`;

export const ViewLink = styled.a`
  font-size: ${fontSizes.fontSizeBody};
  font-weight: 500;
  color: var(--primary);
  text-decoration: none;
  flex: 0 0 auto;
  padding: ${paddings.smallPadding} ${paddings.mediumPadding};
`;
